import localforage from 'localforage';
import { ref, watch } from 'vue';
import { useToast } from 'primevue/usetoast';

import { clearCache } from '../registerServiceWorker';

import { useOfflineData } from '../composables/useOfflineData';
import { useAppVersion } from '../composables/useAppVersion';
import { useNetworkStatus } from '../composables/useNetworkStatus';

export function useDataSync() {
  const { invalidateAllData, invalidateSomeData } = useOfflineData();
  const { isCurrentVersion, updateVersion } = useAppVersion();
  const { isOnline } = useNetworkStatus();

  const isLoading = ref(false);

  const toast = useToast();

  watch(
    isCurrentVersion,
    async () => {
      try {
        if (!isOnline.value || isCurrentVersion.value) return;

        isLoading.value = true;

        updateVersion();
        invalidateAllData();

        await clearCache();

        window.location.reload();
      } catch (error) {
        toast.add({
          severity: 'error',
          summary: 'Wystąpił błąd podczas synchronizacji danych',
          life: 3000,
        });
      } finally {
        isLoading.value = false;
      }
    },
    {
      immediate: true,
    }
  );

  async function syncData() {
    if (!isOnline.value) {
      toast.add({
        severity: 'warn',
        summary: 'Brak połączenia z internetem',
        life: 3000,
      });
      return;
    }

    try {
      isLoading.value = true;

      invalidateAllData();

      await localforage.clear();
      await clearCache();

      window.location.reload();
    } catch (error) {
      toast.add({
        severity: 'error',
        summary: 'Wystąpił błąd podczas synchronizacji danych',
        life: 3000,
      });
    } finally {
      isLoading.value = false;
    }
  }

  return {
    isLoading,
    syncData,
  };
}
